import React from 'react';

import PropTypes from 'prop-types';

import { Avatar } from '../../../../../shared/components/Avatar';
import { Spinner } from '../../../../../shared/components/Spinner';
import { useAuth } from '../../../../../shared/hooks';
import { useForm } from '../../hooks';

import sharedStyles from '../../../../shared/styles/_form.module.scss';
import componentStyles from './MessageForm.module.scss';

const MessageForm = ({ fetchMessages, taskId }) => {
  const { user } = useAuth();

  const { errorMessage, handleChange, handleSubmit, isLoading, messageContent } = useForm(
    {
      fetchMessages,
      taskId,
    }
  );

  const errorAlert = <div className="alert alert-danger alert--form">{errorMessage}</div>;

  return (
    <div className={componentStyles.form}>
      <div className={componentStyles.form__avatar}>
        <Avatar avatarColor={user.avatarColor} initials={user.initials} />
      </div>

      <div className={componentStyles.form__field}>
        <form onSubmit={handleSubmit}>
          <div className={sharedStyles.field}>
            <textarea
              onChange={handleChange}
              required
              rows={3}
              type="text"
              value={messageContent}
            />
          </div>

          <div className={componentStyles.form__button}>
            <button className="btn--primary" disabled={isLoading} type="submit">
              Save
            </button>
          </div>
        </form>

        {isLoading && <Spinner />}

        {errorMessage && errorAlert}
      </div>
    </div>
  );
};

MessageForm.propTypes = {
  fetchMessages: PropTypes.func.isRequired,
  taskId: PropTypes.string.isRequired,
};

export default MessageForm;
